<template>
  <div :class="[print === 'true' ? 'print-div' : '', 'backgroundWhite']">
    <div v-if="!(print == 'true' || no_export == 'true') && items_list" class="export-div" title="Export as CSV">
      <download-csv
        :name="file_name"
        :data="csv_export_data.data"
        :labels="csv_export_data.headers"
        :fields="csv_export_data.fields"
      >
        <v-icon color="vtblue"> mdi-arrow-down-bold-box-outline </v-icon>
      </download-csv>
      <v-data-table
        dense
        v-show="false"
        :headers="headers"
        :items="items_list"
        :item-key="item_key"
        :search="no_search ? '' : $store.state.search_key"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :items-per-page="csv_pagination"
        @current-items="csv_items"
      ></v-data-table>
    </div>
    <div>
      <v-data-table
        class="backgroundWhite"
        show-expand
        :dense="dense ? true : false"
        :expanded.sync="expanded"
        :single-expand="singleExpand"
        :headers="headers"
        :items="items_list"
        :item-key="item_key"
        :search="no_search ? '' : $store.state.search_key"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :items-per-page="itemsPerPage ? itemsPerPage : 10"
        :disable-pagination="no_pagination ? true : false"
        :hide-default-footer="no_pagination ? true : false"
        :disable-sort="no_sort ? true : false"
        @current-items="currentItems"
        :loading="loading"
        @update:sort-by="sortBy = $event"
        @update:sort-desc="sortDesc = $event"
        :footer-props="{ itemsPerPageOptions: customPagination }"
      >
        <template v-for="h in headers" v-slot:[`header.${h.value}`]="{ header }">
          <span :key="`${h.value}_header`">
            <TooltipVT v-if="header.tooltip" type="text" :text="header.tooltip" :title="header.text"></TooltipVT>
            <span v-else>
              {{ header.text }}
            </span>
          </span>
        </template>
        <template v-slot:item="{ item, headers, isExpanded, isMobile }">
          <tr
            :class="{
              'print-tr ': print == 'true',
              info: item_key && !print && selectedRow && selectedRow == item[item_key],
            }"
            :id="item[item_key]"
            :ref="item[item_key]"
            @click="trClick(item)"
          >
            <td
              :class="{
                print: print == 'true',
                'd-flex bottom-border justify-space-between ': isMobile == true,
              }"
              v-bind:style="no_pagination == 'true' ? 'height: 20px;' : 'min-height: 45px;'"
              v-for="(header, indx) in headers"
              :key="`${header.value}_${indx}`"
            >
              <div v-if="isMobile">{{ header.text }}</div>
              <div
                v-if="header.of_type == 'text'"
                :class="`${getValueFromConfig(item[header.value], header.value, 'color')}--text ${getValueFromConfig(
                  item[header.value],
                  header.value,
                  'highlight'
                )}`"
              >
                <TooltipVT
                  v-if="getValueFromConfig(item[header.value], header.value, 'tooltip')"
                  type="text"
                  :text="`${getValueFromConfig(item[header.value], header.value, 'tooltip')}`"
                  :title="`${$emptyCheck(item[header.value])}`"
                ></TooltipVT>
                <MapTooltipVT
                  v-else-if="header.location && header.condition == item[header.value].toLowerCase().trim()"
                  :item="[item]"
                  :map_config="header.location"
                  :text="item[header.value]"
                ></MapTooltipVT>
                <span v-else>
                  <transition :name="computedTransition" mode="out-in">
                    <span :key="`${item[header.value]}`">
                      {{
                        header.caps ? $emptyCheck(item[header.value]).toUpperCase() : $emptyCheck(item[header.value])
                      }}
                    </span>
                  </transition>
                  <span v-if="header.suffix && item[header.value]">{{ header.suffix }}</span>
                </span>
              </div>
              <div
                v-if="header.of_type == 'number'"
                :class="`${getValueFromConfig(item[header.value], header.value, 'color')}--text ${getValueFromConfig(
                  item[header.value],
                  header.value,
                  'highlight'
                )}`"
              >
                <transition :name="computedTransition" mode="out-in">
                  <span :key="`${item[header.value]}`" class="pr-1">{{
                    item[header.value] | round(header.decimal)
                  }}</span>
                </transition>
                <span v-if="(header.suffix || item.suffix) && item[header.value]" class="">{{
                  header.suffix || item.suffix
                }}</span>
              </div>
              <div
                v-if="header.of_type == 'min-max'"
                :class="`${getValueFromConfig(item[header.value], header.value, 'color')}--text `"
              >
                <span class="primaryGrey--text">{{ $emptyCheckNoReturn(item[header.values["min"]]) }}</span>
                <span v-if="item[header.values['min']] || item[header.values['max']]"> /</span
                ><span class="primary--text text-caption"> {{ $emptyCheckNoReturn(item[header.values["max"]]) }}</span>
              </div>
              <div
                v-if="header.of_type == 'multi'"
                :class="`${getValueFromConfig(item[header.value], header.value, 'color')}--text `"
              >
                <span class="borderDark--text" v-for="(val, indx) in header.values" :key="`val_${header.value}_${indx}`"
                  >{{ $emptyCheck(item[val]) | round(header.decimal)
                  }}{{ header.suffix && item[val] ? ` ${header.suffix}` : ""
                  }}<span v-if="indx != header.values.length - 1"> /</span></span
                >
              </div>
              <div
                v-if="header.of_type == 'link'"
                :class="`${getValueFromConfig(item[header.value], header.value, 'color')}--text `"
                v-bind:style="print == 'true' ? 'color: #0581c6' : ''"
              >
                <router-link
                  class="pointer font-weight-bold text-decoration-underline"
                  v-if="header.identifier"
                  target="_blank"
                  :to="getRoute(header.url, header.identifier, item)"
                >
                  {{ $emptyCheck(item[header.value]) }}
                </router-link>
                <!-- <span
                  class="pointer font-weight-bold text-decoration-underline"
                  v-if="item[header.identifier]"
                  @click="open_tab(`${header.url}${item[header.identifier]}`)"
                >
                  {{ $emptyCheck(item[header.value]) }}
                </span> -->
                <span v-else>
                  {{ $emptyCheck(item[header.value]) }}
                </span>
              </div>
              <div v-if="header.of_type == 'multi-link'">
                <span
                  v-for="(param, indx) in item[header.value] || []"
                  :key="`list_${indx}`"
                  :class="`${header.color ? header.color : 'primaryDark'}--text font-weight-black text-caption mr-2`"
                >
                  <router-link class="pointer font-weight-bold" target="_blank" :to="`${header.url}/${param}`">
                    {{ $emptyCheck(param) }}
                  </router-link>
                </span>
              </div>
              <div
                v-if="header.of_type == 'modal'"
                :class="` ${getValueFromConfig(item[header.value], header.value, 'color')}--text ${
                  header.longValue ? 'fxd-width' : ''
                }`"
                @click="rowClick(item, $event)"
              >
                <span class="pointer text-decoration-underline font-weight-bold">{{
                  $emptyCheck(item[header.value])
                }}</span>
                <v-chip
                  x-small
                  v-if="header.value_3 && item[header.value_3] == header.condition"
                  class="ma-2 chips"
                  :color="header.color"
                  >{{ item[header.value_3] }}
                </v-chip>
              </div>
              <div
                v-if="header.of_type == 'date'"
                :class="`${getValueFromConfig(item[header.value], header.value, 'color')}--text `"
              >
                {{ item[header.value] | date }}
              </div>
              <div v-if="header.of_type == 'list'">
                <span
                  v-for="(param, indx) in Object.keys(item[header.value] || [])"
                  :key="`list_${indx}`"
                  :class="`${header.color ? header.color : 'primaryDark'}--text font-weight-black text-caption`"
                >
                  <v-chip :color="header.color" text-color="white" class="ma-2" small>
                    {{ param }} - {{ item[header.value][param] }}
                  </v-chip>
                </span>
              </div>
              <div
                v-if="header.of_type == 'epoch'"
                :class="`${getValueFromConfig(item[header.value], header.value, 'color')}--text `"
              >
                <transition :name="computedTransition" mode="out-in">
                  <span
                    :key="`${item[header.value]}`"
                    :class="`${header.color ? header.color : 'primaryDark'}--text`"
                    >{{ item[header.value] | epochCon }}</span
                  >
                </transition>
              </div>
              <div
                v-if="header.of_type == 'hours'"
                :class="`${getValueFromConfig(item[header.value], header.value, 'color')}--text`"
              >
                {{ item[header.value] | timeSince }}
              </div>
              <div
                v-if="header.of_type == 'ms'"
                :class="`${getValueFromConfig(item[header.value], header.value, 'color')}--text`"
              >
                {{ item[header.value] }}
              </div>
              <div v-if="header.of_type == 'lookup'">
                {{ page_config[header.config][item[header.value]] }}
              </div>
              <div v-if="header.of_type == 'avatar'">
                <v-avatar :color="getValueFromConfig(item[header.value], header.value, 'color')" size="15"> </v-avatar>
              </div>
              <div v-if="header.of_type == 'indicator'">
                <v-tooltip color="primaryGrey" top>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-bind="attrs"
                      v-on="on"
                      :class="'fxd-con ' + getValueFromConfig(item[header.valueOf], header.valueOf, 'color')"
                    ></div>
                  </template>
                  <span>{{ header.valueOf }} : {{ item[header.valueOf] }}</span>
                </v-tooltip>
              </div>
              <div v-if="header.of_type == 'tooltip'">
                <span v-if="item['Status'] == 3 && header.value in item && item[header.value] == 0">0</span>
                <span v-else>
                  <span v-if="!(header.value in item) && item['Status'] != 3">
                    <v-tooltip color="warning" top>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">Unknown</span>
                      </template>
                      <span
                        ><b>Status:</b> {{ page_config.Status[item["Status"]] }}<br /><b>Operation:</b
                        >{{ page_config.Operation[item["Operation"]] }}</span
                      >
                    </v-tooltip></span
                  >
                  <span v-else>{{ item[header.value] | round(header.decimal || 2) }} </span>
                </span>
              </div>
              <div v-if="header.of_type == 'more_info'">
                <v-tooltip color="borderDark" top>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on"
                      >{{ item[header.value]
                      }}<v-icon small color="primary" v-if="header.icon">{{ header.icon }}</v-icon></span
                    >
                  </template>
                  <div>
                    <div v-for="(param, indx) in header.values" :key="`more_info_${indx}`">
                      <span class="text-subtitle-2"
                        >{{ param.label }}:
                        <span class="text-subtitle-1 font-weight-bold">{{ item[param.value] }}</span>
                        {{ param.suffix }}</span
                      >
                    </div>
                  </div>
                </v-tooltip>
              </div>
              <div v-if="header.of_type == '2-line-text'">
                <div v-bind:style="no_pagination == 'true' ? 'min-width: 70px;' : ''">
                  <b>{{ $emptyCheck(item[header.value].toLowerCase()) }}</b>
                  <v-chip
                    x-small
                    v-if="header.value_3 && item[header.value_3] == header.condition"
                    class="ma-2"
                    :color="header.color"
                    >{{ item[header.value_3] }}
                  </v-chip>
                </div>
              </div>
              <div v-if="header.of_type == 'highlight'">
                <v-chip
                  x-small
                  class="ma-2"
                  :color="
                    item[headers[1].value] != 1 && item[header.value] && item[header.value] > header.condition
                      ? header.color
                      : 'backgroundWhite'
                  "
                  >{{ item[header.value] | timeSince }}
                </v-chip>
                <TooltipVT
                  v-if="item[headers[1].value] == 1 && item[header.value] && item[header.value] > header.condition"
                  icon="mdi-information-variant"
                  color="primary"
                  text="Trip not started yet!"
                ></TooltipVT>
              </div>
              <div v-if="header.of_type == 'primary_icon'">
                <v-chip
                  class="opaque-img px-4 py-5 ma-2"
                  :color="`${getValueFromConfig(item[header.value], header.value, 'color')} lighten-4`"
                  label
                  :text-color="getValueFromConfig(item[header.value], header.value, 'color')"
                >
                  <v-icon>{{
                    getValueFromConfig(item[header.value], header.value, "icon")
                      ? getValueFromConfig(item[header.value], header.value, "icon")
                      : primary_icon
                  }}</v-icon>
                </v-chip>
              </div>
              <div class="position-relative" v-if="header.of_type == 'to-from'">
                <div class="border-arrow-line">
                  <div class="arrow-data">
                    {{ item[header.value] | timeSince }}
                  </div>
                </div>
                <div class="border-arrow curvy"></div>
              </div>

              <div v-if="header.of_type == 'image'">
                <v-chip
                  v-if="!item[header.value]"
                  class="px-4 py-5 my-2 rounded"
                  color="primaryGrey lighten-4"
                  text-color="primaryGrey"
                >
                  <v-icon small>mdi-image-off-outline</v-icon>
                </v-chip>
                <v-img
                  v-if="item[header.value]"
                  class="my-2 rounded"
                  :height="header.height"
                  :width="header.width"
                  :src="`${header.url}${item[header.value]}`"
                ></v-img>
              </div>
              <div v-if="header.of_type == 'secondary_icon'">
                <TooltipVT
                  :icon="getValueFromConfig(item[header.value], header.value, 'icon')"
                  :color="getValueFromConfig(item[header.value], header.value, 'color')"
                  :text="item[header.value]"
                ></TooltipVT>
                <span v-if="item[header.value] == 'Temperature'">85°C</span>
              </div>
              <div v-if="header.of_type == 'icons'" class="d-flex">
                <div v-for="(issue, indx) in header.values" :key="`issue_${indx}`">
                  <TooltipVT
                    v-if="item[issue] || header.show_icons"
                    :color="`${item[issue] ? 'vtred' : 'borderLight'}`"
                    :text="page_config[header.config][issue].label"
                    :icon="page_config[header.config][issue].icon"
                  >
                  </TooltipVT>
                </div>
              </div>
              <div v-if="header.of_type == 'object'">
                <div class="d-flex mb-4">
                  <div class="d-flex flex-column" v-for="(row, key) in header.values" :key="`row_${key}`">
                    <div class="mx-4 font-weight-bold">
                      {{ row }}
                    </div>
                    <div class="mx-4" v-for="(field, indx) in item[header.value]" :key="`field_${indx}`">
                      {{ field[key] }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="header.of_type == 'action'">
                <v-btn
                  v-if="
                    header.value != 'moreActions' &&
                    header.condition &&
                    ((!header.check && item[header.condition]) ||
                      header.condition == 'none' ||
                      (header.check && !item[header.condition]))
                  "
                  color="primaryGrey"
                  icon
                  v-on:click.stop="$emit('action', [header.value, item])"
                >
                  <v-icon>{{ get_icon(header.value) }}</v-icon>
                </v-btn>
                <v-menu offset-y v-if="header.value == 'moreActions'">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn outlined class="py-4 px-1" x-small color="restingOutline" v-bind="attrs" v-on="on">
                      <v-icon color="primaryGrey">{{ get_icon(header.value) }}</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item
                      v-for="(menuItem, idx) in header.values"
                      :key="idx"
                      v-on:click="
                        $emit('action', {
                          key: header.value,
                          item: item,
                          action: menuItem,
                        })
                      "
                    >
                      <v-list-item-title>{{ header.labels[idx] }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
              <div v-if="header.of_type == 'accordion'">
                <v-btn v-if="!isExpanded" color="primaryGrey" icon v-on:click.stop="expandRow(item)">
                  <v-icon>{{ get_icon(header.expand) }}</v-icon>
                </v-btn>
                <v-btn v-else color="primaryGrey" icon v-on:click.stop="collapseRow(item)">
                  <v-icon>{{ get_icon(header.collapse) }}</v-icon>
                </v-btn>
              </div>
              <div v-if="header.of_type == 'add_to_list'">
                <v-btn icon color="primaryOutline" v-on:click.stop="$emit('add-to-list', item)">
                  <v-icon>{{ getValueFromConfig(item[header.value], header.value, "icon") }}</v-icon>
                </v-btn>
              </div>
              <div v-if="header.of_type == 'rating'">
                {{ $percentage(item[header.value]) }}
                <span class="primaryGrey--text"></span>
              </div>
              <div v-if="header.of_type == 'bar'">
                <DistributionBarVT :values="header.values" :item="item" :colors="header.colors" :labels="header.labels">
                </DistributionBarVT>
              </div>
              <div v-if="header.of_type == 'perc'">
                <v-tooltip color="primaryGrey" top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-progress-linear
                      v-bind="attrs"
                      v-on="on"
                      height="10"
                      background-color="restingOutline"
                      :color="`${item[header.value] >= 90 ? 'primary' : 'lightYelow'}`"
                      :value="get_rounded_value(item[header.value], header.decimals)"
                    ></v-progress-linear>
                  </template>
                  <span class="font-weight-bold">{{ get_rounded_value(item[header.value], header.decimals) }}%</span>
                </v-tooltip>
              </div>
              <div v-if="header.of_type == 'vbar'">
                <v-tooltip color="primaryGrey" top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-progress-linear
                      v-bind="attrs"
                      v-on="on"
                      height="13"
                      class="vbar"
                      rounded
                      :color="`${item[header.value] < 50 ? 'primary' : 'lightYelow'}`"
                      :value="item[header.value]"
                    ></v-progress-linear>
                    <!-- <v-progress-circular
                      v-bind="attrs"
                      :size="25"
                      :width="5"
                      v-on="on"
                      :color="`${
                        item[header.value] < 50 ? 'primary' : 'lightYelow'
                      }`"
                      :value="item[header.value]"
                    ></v-progress-circular> -->
                  </template>
                  <span class="font-weight-bold">{{ item[header.value] }}%</span>
                </v-tooltip>
              </div>
              <div v-if="header.of_type == 'switch'">
                <v-icon v-if="item[header.value]" :color="header.color">{{ header.icon }}</v-icon>
              </div>
              <div v-if="header.of_type == 'toggle_switch'">
                <v-switch
                  :success="item[header.value]"
                  flat
                  @change="(e) => $emit('toggleSwitch', { id: item[header.id], is_active: e })"
                ></v-switch>
              </div>
              <div v-if="header.of_type == 'raw_html'">
                <span v-html="item[header.value]"></span>
              </div>
              <div v-if="header.of_type == 'chips'">
                <span v-if="item[header.value] && item[header.value].length > 0">
                  <v-chip
                    v-for="(tag, index) in item[header.value]"
                    :key="`${header.value}_${index}`"
                    x-small
                    class="mr-1 mb-1 chips font-weight-bold"
                    color="secondary"
                    outlined
                    label
                  >
                    {{ tag }}
                  </v-chip>
                </span>
                <span v-else>-</span>
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:expanded-item="{ item, headers }">
          <td :colspan="headers.length" class="expanded-row backgroundWhite py-4 px-8 mx-auto top-border bottom-border">
            <transition name="fade">
              <slot v-bind:item="item"></slot>
            </transition>
          </td>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import DistributionBarVT from "../components/DistributionBarVT";
import TooltipVT from "../components/TooltipVT";
import MapTooltipVT from "../components/MapTooltipVT";

export default {
  name: "DataTableVT",
  components: { DistributionBarVT, TooltipVT, MapTooltipVT },
  props: {
    dense: String,
    expand: String,
    headers: Array,
    items_list: Array,
    sub_items: Array,
    sub_headers: Array,
    primary_icon: String,
    sort_by: String,
    sort_asc: Boolean,
    item_key: String,
    no_search: Boolean,
    no_pagination: String,
    no_sort: String,
    print: String,
    no_export: String,
    itemsPerPage: Number,
    selected_row: String,
    loading: Boolean,
    custom_pagination: Array,
    isTransitionOn: {
      default: true,
      required: false,
      type: Boolean,
    },
  },
  watch: {
    selected_row: function (newVal) {
      this.selectedRow = newVal;
      this.$nextTick(() => {
        document.getElementById(newVal).scrollIntoView({ behavior: "smooth" });
      });
    },
  },
  data: function () {
    return {
      sortBy: this.sort_by || this.headers[0].value,
      sortDesc: this.sort_asc ? false : true,
      expanded: [],
      singleExpand: false,
      selectedRow: null,
      decimal: 10,
      filtered_data: null,
      csv_pagination: -1,
    };
  },
  methods: {
    currentItems: function (value) {
      if (value) this.$emit("filteredItems", value);
    },
    csv_items: function (value) {
      this.filtered_data = value;
    },
    getRoute: function (url, identifier, value) {
      if (typeof identifier == "string") return `${url}${value[identifier]}`;
      identifier.map((elem, i) => {
        let separater = i + 1 < identifier.length ? "/" : "";
        url = url + value[elem] + separater;
      });
      return url;
    },
    getValueFromConfig(value, key, type) {
      value = typeof value === "object" && value && value.length > 0 ? value[0] : value;

      value = (value && typeof value == "string" && value.trim()) || value;
      let valueLower = (value && typeof value == "string" && value.trim().toLowerCase()) || value;

      return (
        (this.page_config[key] && this.page_config[key][type] && this.page_config[key][type][value]) ||
        (this.page_config[key] && this.page_config[key][type] && this.page_config[key][type][valueLower]) ||
        (type == "color" ? "primaryDark" : "")
      );
    },
    rowClick(item, event) {
      const eventData = { ...item, ctrlKey: event.ctrlKey };
      this.$emit("rowClick", eventData);
    },
    trClick(item) {
      this.$emit("trClick", item);
    },
    expandRow(item) {
      if (this.expand) {
        this.expanded.push(item);
      }
      this.$emit("expandRow", item);
    },
    collapseRow(item) {
      let id = this.item_key;
      if (this.expand && this.item_key) {
        var removeIndex = this.expanded
          .map(function (elem) {
            return elem[id];
          })
          .indexOf(item[this.item_key]);
        this.expanded.splice(removeIndex, 1);
      }
    },
    get_icon(value) {
      return value == "moreActions" ? "mdi-dots-vertical" : value;
    },
    get_rounded_value(value, decimal) {
      return decimal !== undefined && decimal !== null ? Number.parseFloat(value).toFixed(decimal) : value;
    },
    // open_tab(path) {
    //   let routeData = this.$router.resolve({ path: path });
    //   window.open(routeData.href, "_blank");
    // },
  },
  created() {
    this.page_config = this.$config;
  },
  computed: {
    computedTransition() {
      // Empty string is used to disable transition
      return this.isTransitionOn ? "fade" : "";
    },
    customPagination() {
      return this.custom_pagination && this.custom_pagination.length > 0 ? this.custom_pagination : [10, 25, 50];
    },
    csv_export_data() {
      let headers = {};
      let fields = [];
      let data_type = {};
      if (!this.filtered_data || this.filtered_data.length < 0) {
        return { headers, fields, data: [] };
      }
      let data = JSON.parse(JSON.stringify(this.filtered_data));
      this.headers.map((elem) => {
        if (elem.text && elem.value) {
          fields.push(elem.value);
          headers[elem.value] = elem.text;
          data_type[elem.value] = elem.of_type;
        }
      });

      data &&
        data.map((elem) => {
          for (let key of Object.keys(elem)) {
            if (data_type[key]) {
              let prop_value = elem[key];
              if (data_type[key] == "date") {
                elem[key] = this.$options.filters.date(prop_value);
              } else if (data_type[key] == "hours") {
                elem[key] = this.$options.filters.timeSince(prop_value);
              } else if (data_type[key] == "rating") {
                elem[key] = this.$percentage(prop_value);
              } else {
                elem[key] = prop_value;
              }
            }
          }
          return elem;
        });
      return { headers, fields, data };
    },
    file_name: function () {
      return "data_" + new Date().toString() + ".csv";
    },
  },
};
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease-out;
}

.fade-enter {
  opacity: 0;
  background-color: transparent;
}

.fade-enter-to {
  opacity: 1;
  background-color: transparent;
}

.fade-leave {
  opacity: 1;
  background-color: #0582c650;
}

.fade-leave-to {
  opacity: 0;
  background-color: #0582c650;
}

span {
  display: inline-block;
  border-radius: 8px;
}

.print-div {
  .export-div {
    display: none;
  }

  ::v-deep .v-data-table {
    .top-border {
      border-top: 2px solid var(--v-primaryOutline-base);
    }

    .bottom-border {
      border-bottom: 2px solid var(--v-primaryOutline-base);
    }

    tbody tr td.bottom-border {
      border-bottom: 2px solid var(--v-primaryOutline-base) !important;
    }

    tbody tr td div.fxd-con {
      height: 30px;
      width: 20px;
    }

    thead {
      tr {
        background-color: var(--v-background-base);
        opacity: 1;
        border-bottom: 1px solid var(--v-border-base) !important;

        th {
          border: none !important;
          color: var(--v-primarGrey-base) !important;
          white-space: nowrap;
          height: 30px;
          font-size: 11px;
          padding-left: 5px;
          padding-right: 5px;
        }
      }
    }

    tbody {
      tr.print-tr {
        td.print {
          font-size: 10px;
          padding: 0 6px 0 6px;
        }
      }

      tr:nth-child(even) {
        background: var(--v-backgroundLight-base);
      }
    }
  }
}

::v-deep .v-data-footer {
  border: none !important;
}

.export-div {
  margin-right: 0.5rem;
  display: flex;
  flex-direction: row-reverse;
}

::v-deep .v-data-table {
  max-width: inherit;
  overflow: auto;

  .vbar {
    transform: rotate(-90deg);
    max-width: 22px;
  }

  thead {
    tr {
      background-color: var(--v-backgroundLight-base);
      opacity: 0.4;
      border: none !important;

      th {
        border: none !important;
        color: var(--v-titleLight-base) !important;
        white-space: nowrap;
      }
    }
  }

  tbody {
    border: none !important;

    tr:hover {
      background-color: var(--v-backgroundLight-base) !important;

      .border-arrow-line {
        border-bottom: 2px dotted #eee;
        background:
          linear-gradient(#eee, #eee) padding-box,
          linear-gradient(to right, var(--v-primaryOutline-lighten4), var(--v-primaryOutline-base)) border-box;
      }
    }

    tr.active {
      td:nth-last-child(2) {
        background: var(--v-secondary-lighten2);
      }
    }

    tr {
      border: none !important;

      td.print {
        .border-arrow-line {
          height: 6px;
          width: 56px;
          right: 0;
          border-bottom: 2px dotted var(--v-primaryOutline-base);

          .arrow-data {
            position: absolute;
            top: -12px;
            width: 60px;
            font-size: 0.65rem;
            text-align: center;
          }
        }

        .border-arrow {
          left: 4rem;
        }
      }

      td {
        color: var(--v-primaryDark-base) !important;
        border: none !important;
        div.fxd-width {
          min-width: 100px;
        }

        div.fxd-con {
          height: 30px;
          width: 15px;
          border-radius: 12%;
          -webkit-filter: drop-shadow(5px 0px 3px #325597);
          filter: drop-shadow(1px 0px 1px #325597);
        }

        .pointer {
          cursor: pointer;
        }

        .opaque-img {
          opacity: 0.7;
        }

        .position-relative {
          position: relative;
          width: 85px;
        }

        .border-arrow-line {
          height: 5px;
          width: 80px;
          border-bottom: 2px dotted #fff;
          position: absolute;
          left: 0em;
          border-image-slice: 1;
          background:
            linear-gradient(#fff, #fff) padding-box,
            linear-gradient(to right, var(--v-primaryOutline-lighten4), var(--v-primaryOutline-base)) border-box;

          .arrow-data {
            position: absolute;
            top: -12px;
            width: 80px;
            font-size: 0.65rem;
            text-align: center;
          }
        }

        .border-arrow {
          position: absolute;
          right: -1em;
          width: 10px;
          height: 10px;
          border: 2px solid var(--v-primaryOutline-base);
          border-width: 2px 2px 0 0;
          transform: translateX(-14px) rotate(45deg);
        }

        .border-arrow.curvy {
          border-width: 2px 2px 0 0;
          border-radius: 2px;
        }
        .v-chip.v-size--x-small.chips {
          line-height: 15px;
        }
      }
    }
  }
}
</style>
